import React from 'react';
import { Box, Text, Table, Thead, Tbody, Tr, Th, Td } from '@chakra-ui/react';
import { Icon } from 'src/components/atoms/Icon';

export type CampaignGroup = {
  id: string;
  groupName: string;
  campaigns: number;
  created: string;
};

type CampaignGroupsTableProps = {
  groups: CampaignGroup[];
  onGroupClick: (group: CampaignGroup) => void;
  onManageClick: (group: CampaignGroup) => void;
};

export const CampaignGroupsTable: React.FC<CampaignGroupsTableProps> = ({
  groups,
  onGroupClick,
  onManageClick,
}) => {
  return (
    <Box maxHeight="600px" overflowY="auto" width="100%">
      <Table variant="simple" width="100%">
        <Thead>
          <Tr
            bg="surface.sidebarMuted"
            borderBottom="1px"
            borderColor="surface.border">
            <Th
              color="content.label"
              fontWeight="semibold"
              fontSize="sm"
              px={4}
              py={4}
              verticalAlign="middle">
              Group Name
            </Th>
            <Th
              color="content.label"
              fontWeight="semibold"
              fontSize="sm"
              px={4}
              py={4}
              verticalAlign="middle">
              Campaigns
            </Th>
            <Th
              color="content.label"
              fontWeight="semibold"
              fontSize="sm"
              px={4}
              py={4}
              verticalAlign="middle">
              Created
            </Th>
            <Th
              color="content.label"
              fontWeight="semibold"
              fontSize="sm"
              px={4}
              py={4}
              verticalAlign="middle">
              Manage
            </Th>
          </Tr>
        </Thead>
        <Tbody>
          {groups.map((group) => (
            <Tr
              key={group.id}
              borderBottom="1px"
              borderColor="surface.border"
              _hover={{ bg: 'sidebar.itemHoverBg' }}>
              <Td fontSize="md" color="content.title" px={4} py={4}>
                <Text
                  cursor="pointer"
                  _hover={{
                    color: 'icon.green',
                    textDecoration: 'underline',
                  }}
                  onClick={() => onGroupClick(group)}>
                  {group.groupName}
                </Text>
              </Td>
              <Td fontSize="md" color="content.title" px={4} py={4}>
                <Text>{group.campaigns}</Text>
              </Td>
              <Td fontSize="md" color="content.title" px={4} py={4}>
                {group.created}
              </Td>
              <Td px={4} py={4}>
                <Icon
                  iconName="pencil"
                  boxSize={5}
                  color="content.muted"
                  cursor="pointer"
                  onClick={() => onManageClick(group)}
                  _hover={{ color: 'icon.green' }}
                />
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </Box>
  );
};
